<template>
    <div class="relative mb-16">
        <div aria-hidden="true" class="absolute inset-0 flex items-center">
            <div class="w-full border-t border-primary-20"></div>
        </div>
        <div class="relative flex items-center justify-between gap-8">
            <h2 class="text-body bg-white text-black first-letter:uppercase pr-8">
                {{ title }}
            </h2>
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: "ApplicationTitle",
    props: {
        title: {
            type: String,
            required: true,
        },
    },
}
</script>
<style scoped>

</style>